import React, { AriaAttributes } from 'react';
import { useId } from '@floating-ui/react';
import * as styles from './Sparkle.module.scss';
import { Icon, IconList, Toggletip } from 'components/core';

type SparkleProps = {
  iconStyle?: 'light' | 'solid';
} & AriaAttributes;

export const Sparkle = ({
  iconStyle = 'light',
  ...ariaProps
}: SparkleProps) => {
  return (
    <Icon
      icon={IconList[iconStyle].faSparkle}
      className={styles.sparkle}
      size="sm"
      {...ariaProps}
    />
  );
};

export const SparkleWithTooltip = ({
  id,
  label,
  variant,
  iconStyle = 'light',
}: {
  id?: string;
  label: string;
  variant?: 'right';
  iconStyle?: 'light' | 'solid';
}) => {
  const idPrefix = useId();
  const classes = [styles.wrapper];
  if (variant) classes.push(styles[variant]);

  return (
    <span id={id} className={classes.join(' ')}>
      <Toggletip
        idPrefix={`${idPrefix}-sparkle`}
        variant="dark"
        icon={IconList[iconStyle].faSparkle}
        ariaLabel={`${label} suggestion info`}
        contentClassName={styles.tooltipMessage}
      >
        Suggestions offered during extraction
      </Toggletip>
    </span>
  );
};
